// extracted by mini-css-extract-plugin
export default {"table_wrapper":"Quiz_table_wrapper__EMbxS","add_new":"Quiz_add_new__hZrC7"};